import { AllieNotFoundIcon, AllieText } from "@allie/app-ui-lib";
import { isMobile } from "../../helpers";
import {
  TokenValidationErrorContainer,
  TokenValidationErrorIcon,
  TokenValidationErrorTitle,
} from "./TokenValidation.styles";

export const TokenValidationError: React.FC<{ message: string }> = ({ message }) => {
  return (
    <TokenValidationErrorContainer>
      <TokenValidationErrorTitle>
        <AllieText type="h3">{message}</AllieText>
      </TokenValidationErrorTitle>
      <TokenValidationErrorIcon>
        <AllieNotFoundIcon size={`${isMobile ? 100 : 150}`} />
      </TokenValidationErrorIcon>
    </TokenValidationErrorContainer>
  );
}
